<template>
  <b-overlay
    :show="busy"
    spinner-type="grow"
    spinner-variant="primary"
    rounded="sm"
  >
    <b-card class="border-none py-0 mb-0 px-1">
      <b-card-body class="py-0">
        <b-row>
          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group label-cols="12" label="Issue Date" label-size="sm">
              <b-input-group>
                <daterangepicker
                  size="sm"
                  ref="issued_at"
                  v-model="issued_at"
                  :opens="'right'"
                  :locale-data="locale_data"
                  :ranges="locale_ranges"
                  :showDropdowns="true"
                  :linkedCalendars="true"
                  :single-date-picker="'range'"
                >
                </daterangepicker>
                <b-input-group-append>
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    @click="
                      issued_at = {
                        startDate: null,
                        endDate: null,
                      }
                    "
                  >
                    <i class="fa fa-remove"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group label-cols="12" label="Client SL A/C" label-size="sm">
              <treeselect
                placeholder="Select slac..."
                searchPromptText="Type at least 3 chars..."
                v-model="slac"
                :clearable="true"
                :multiple="true"
                :async="true"
                :load-options="treeselect_loadSLAC"
                :show-count="true"
                :flatten-search-results="true"
                :disable-branch-nodes="true"
                :matchKeys="['id']"
                search-nested
                :disabled="readonly"
              >
                <div slot="value-label" slot-scope="{ node }">
                  {{ node.raw.id }}
                </div>
              </treeselect>
            </b-form-group>
          </b-col>

          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group label-cols="12" label="Locator" label-size="sm">
              <b-input-group>
                <b-form-input
                  size="sm"
                  v-model="locator"
                  :debounce="options.debounce"
                  placeholder="Locator"
                  trim
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    @click="locator = ''"
                  >
                    <i class="fa fa-remove"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>

          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group label-cols="12" label="Ticket No" label-size="sm">
              <b-input-group>
                <b-form-input
                  size="sm"
                  v-model="ticketno"
                  :debounce="options.debounce"
                  placeholder="Ticket No"
                  trim
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    @click="ticketno = ''"
                  >
                    <i class="fa fa-remove"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group
              label="Different Current Routing?"
              label-for="differences"
              label-cols="12"
            >
              <treeselect
                instanceId="differences"
                type="number"
                v-model="differences"
                :clearable="true"
                :options="differences_options"
              ></treeselect>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
    <b-card class="border-none py-0 mb-0 px-1">
      <b-card-header class="py-1 mb-2">
        <i :class="options.icon" class="mr-1"></i>
        Tickets Route fix
      </b-card-header>

      <b-card-body class="py-0">
        <div>
          <b-overlay
            :show="options.overlay_show"
            opacity=".9"
            v-click-outside="outside"
          >
            <div class="availtable datatable nested">
              <b-table
                :dark="$store.state.darkMode"
                :ref="options.bvtid"
                sticky-header="350px"
                striped
                hover
                small
                caption-bottom
                show-empty
                selectable
                select-mode="multi"
                foot-clone
                no-footer-sorting
                :busy="this[options.bvtid + '_busy']"
                :items="this[options.bvtid + '_items']"
                :fields="options.fields"
                :filter="this[options.bvtid + '_find']"
                @row-selected="rowSelected($event, options.bvtid)"
              >
                <template #head(selected)>
                  <i
                    id="selectall"
                    class="ml-1"
                    :class="headselected(options.bvtid)"
                    aria-hidden="true"
                    @click="headselectedClick(options.bvtid)"
                    title="Click to select/unselect all"
                  ></i>
                  <b-tooltip
                    target="selectall"
                    triggers="hover"
                    placement="right"
                    >Click to select/unselect all</b-tooltip
                  >
                </template>
                <template #cell(selected)="{ rowSelected }">
                  <template v-if="rowSelected">
                    <span aria-hidden="true">&check;</span>
                    <span class="sr-only">Selected</span>
                  </template>
                  <template v-else>
                    <span aria-hidden="true">&nbsp;</span>
                    <span class="sr-only">Not selected</span>
                  </template>
                </template>
                <template v-slot:table-busy>
                  <div class="text-center my-2">
                    <b-spinner
                      type="grow"
                      variant="primary"
                      class="align-middle mr-2"
                    ></b-spinner>
                    <strong class="text-primary">Loading...</strong>
                  </div>
                </template>
                <template v-slot:cell(icon)="slot">
                  <i :class="rowIcon(slot.item)"></i>
                </template>

                <template v-slot:cell()="row">
                  <div
                    v-if="
                      options.badges &&
                      options.badges.find((obj) => obj.key == row.field.key)
                    "
                  >
                    <span
                      v-html="
                        rowBadgeCell(
                          row.item,
                          options.badges.find(
                            (obj) => obj.key == row.field.key
                          ),
                          options
                        )
                      "
                    ></span>
                  </div>
                  <div v-else>{{ row.value }}</div>
                </template>
                <template v-if="options.actions" v-slot:cell(actions)="row">
                  <div id="actions-container" v-if="options.actions_as_elipses">
                    <b-button
                      variant="link"
                      size="sm"
                      title="Actions"
                      :id="'popover-target-' + row.item.id"
                      @click="$root.$emit('bv::hide::popover')"
                    >
                      <i class="fa fa-ellipsis-h text-primary"></i>
                    </b-button>
                    <b-popover
                      container="actions-container"
                      triggers="click blur"
                      placement="leftbottom"
                      :target="'popover-target-' + row.item.id"
                    >
                      <div>
                        <b-nav vertical>
                          <b-nav-item
                            :title="action.label"
                            v-for="action in rowActionCell(row.item, options)"
                            :key="action.key"
                            @click.stop="
                              rowClick(action.key, row, options.bvtid)
                            "
                          >
                            <b-row class="px-2">
                              <b-col class="px-0">
                                <span class="text-normal">{{
                                  action.label
                                }}</span>
                              </b-col>
                              <b-col cols="1">
                                <i :class="rowActionIcon(action, row.item)"></i>
                              </b-col>
                            </b-row>
                          </b-nav-item>
                        </b-nav>
                      </div>
                    </b-popover>
                  </div>
                  <div v-else>
                    <b-button
                      variant="link"
                      size="sm"
                      v-for="action in rowActionCell(row.item, options)"
                      :key="action.key"
                      @click.stop="rowClick(action.key, row, options.bvtid)"
                      :title="action.label"
                    >
                      <i :class="rowActionIcon(action, row.item)"></i>
                    </b-button>
                  </div>
                </template>

                <template v-slot:row-details>
                  <b-card>
                    <component
                      :is="options.component.name"
                      :selection="btable_selected"
                      :config="cconfig"
                      @discard="toolClick('discard')"
                      @refresh="toolClick('refresh')"
                    ></component>
                  </b-card>
                </template>
                <template v-slot:foot()="row">
                  <span v-if="row.field.totalled" class="strong text-primary">
                    {{ row.field.total }}</span
                  >
                  <span v-else></span>
                </template>
              </b-table>
            </div>

            <template #overlay>
              <div class="text-center">
                <p id="cancel-label">{{ options.overlay.message }}</p>
                <hr />
                <b-row>
                  <b-col>
                    <b-button
                      v-for="(button, index) in options.overlay.buttons"
                      :key="index"
                      :style="button.style ? button.style : 'width: 80px'"
                      :class="
                        button.class
                          ? button.class
                          : button.dispatch
                          ? null
                          : 'ml-2'
                      "
                      :variant="
                        button.variant
                          ? button.variant
                          : button.dispatch
                          ? 'outline-primary'
                          : 'outline-secondary'
                      "
                      :size="button.size ? button.size : 'sm'"
                      :squared="button.squared ? button.squared : true"
                      @click="
                        button.dispatch
                          ? dispatcher(button.dispatch)
                          : (options.overlay_show = false)
                      "
                      >{{ button.label }}</b-button
                    >
                  </b-col>
                </b-row>
              </div>
            </template>
          </b-overlay>
          <b-row class="excelsheetbuttons px-1 mb-3 mt-n2">
            <b-col>
              <div v-if="busy">
                <i class="fa fa-spinner fa-spin"></i>
                <span class="ml-1">Updating ...</span>
              </div>
              <span class="small" v-if="!busy"
                >Found {{ this[options.bvtid + "_items"].length }} rows</span
              >
            </b-col>

            <b-col class="text-right">
              <b-link
                id="flights-excel"
                class="mt-1 mr-1 excel"
                @click="
                  table_excel({ items: excelitems, fields: options.fields })
                "
                title="Send to excel"
              >
                <i class="fa fa-file-excel-o" aria-hidden="true"></i>
              </b-link>
              <b-tooltip target="flights-excel" triggers="hover"
                >Grid to excel</b-tooltip
              >
              <b-link
                id="flights-refresh"
                class="mt-1 excel"
                @click="load"
                title="Refresh"
              >
                <i class="fa fa-refresh" aria-hidden="true"></i>
              </b-link>
              <b-tooltip target="flights-refresh" triggers="hover"
                >Refresh</b-tooltip
              >
            </b-col>
          </b-row>
        </div>
      </b-card-body>

      <b-card-footer class="mt-2">
        <b-row align-h="end">
          <b-col class="text-left">
            <div v-if="busy">
              <i class="fa fa-spinner fa-spin text-primary"></i>
            </div>
            <div v-else>
              <span v-html="message"></span>
            </div>
          </b-col>
          <b-col class="text-right" cols="8">
            <b-button
              squared
              size="sm"
              variant="secondary"
              class="mr-1"
              @click="discard"
            >
              <i class="fa fa-chevron-left pr-1"></i>Back
            </b-button>
            <b-button
              squared
              size="sm"
              variant="primary"
              @click="saveit"
              :disabled="this[this.options.bvtid + '_selected'] == 0"
            >
              <i class="fa fa-check"></i>
              Sync It
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
  </b-overlay>
</template>

<script>
import gql from "graphql-tag";

export default {
  name: "TicketsRoutefix",
  data() {
    return {
      busy: false,
      issued_at: {
        startDate: this.$moment().format("YYYY-MM-DD"),
        endDate: this.$moment().format("YYYY-MM-DD"),
      },
      ticketno: "",
      locator: "",
      slac: [],
      differences: true,
      multiple: true,
      showedit: true,
      line: {},
      item: {},
      items: [],
      differences_options: [
        {
          id: true,
          label: "Yes",
        },
        {
          id: false,
          label: "No",
        },
      ],
      options: {
        title: "Tickets Route fix",
        icon: "fa fa-location-arrow text-primary",
        debounce: 500,
        bvtid: "ctable",
        fields: [
          {
            key: "selected",
            label: "...",
            class: "text-center w-25px",
          },
          {
            key: "icon",
            label: "",
            class: "text-center w-30px",
          },
          {
            key: "ticketno",
            label: "Ticket",
            sortable: true,
            class: "text-center",
          },
          {
            key: "type",
            label: "Type",
            sortable: true,
            class: "text-center",
          },
          {
            key: "locator",
            label: "Locator",
            sortable: true,
            class: "text-center",
          },

          {
            key: "dateissued",
            label: "Date Issued",
            sortable: true,
            class: "text-center",
          },
          {
            key: "passenger",
            label: "Passenger",
            sortable: true,
            class: "text-left",
          },
          {
            key: "slac",
            label: "SL A/C",
            sortable: true,
            class: "text-center",
          },
          {
            key: "eventcode",
            label: "Event",
            sortable: true,
            class: "text-center",
          },
          {
            key: "agent",
            label: "Agent",
            sortable: true,
          },
          {
            key: "datetravel",
            label: "Date Travel",
            sortable: true,
            class: "text-center",
            formatter: (value, key, item) => {
              let result = "";
              if (value) {
                result = value.split(" ")[0];
              }
              return result;
            },
          },
          {
            key: "routing",
            label: "Current Routing",
            sortable: true,
          },
          {
            key: "data",
            label: "Repository Route",
            sortable: true,
          },
          {
            key: "status",
            label: "Status",
            sortable: true,
          },
        ],
        badges: [
          {
            key: "ticketno",
            type: "pill",
            class: "orange",
          },
          {
            key: "locator",
            type: "pill",
            class: "secondary",
          },
 {
            key: "type",
            type: "badge",
            Charter: "primary",
            Ticket: "primary",
            Reissue: "primary",
            Void: "white",
            Refund: "white",
            EMD: "purple",
          },
          {
            key: "status",
            type: "badge",
            ready: "primary",
            fixed: "info",
          },
        ],
        actions: [],
        actions_as_elipses: false,
        modal: {},
        component: {},
        overlay_show: false,
        overlay: {},
      },
    };
  },
  mounted() {
    this.load();
  },
  watch: {
    async issued_at() {
      await this.load();
    },
    async slac() {
      await this.load();
    },
    async locator() {
      await this.load();
    },
    async ticketno() {
      await this.load();
    },
    async differences() {
      await this.load();
    },
  },
  computed: {
    readonly() {
      return false;
    },
  },
  methods: {
    async loadDDL() {
      console.log("loadDDL");
      this.busy = true;

      this.busy = false;
    },
    async load() {
      this.busy = true;

      console.log(this.issued_at);
      // if (this.selection.length > 0) {
      //   this.dateissuedfrom = null;
      //   this.dateissuedto = null;
      //   this.locator = null;
      //   this.ticketno = null;
      // }

      let selset = [];
      this.selection.forEach(function (v) {
        selset.push({ ticketno: v.ticketno });
      });

      let variables = {
        dateformat: "DD/MM/YYYY",
        // iszhold: true,
      };

      if (selset.length) {
        variables.selected = selset;
      } else {
        variables.dateissued = this.issued_at.startDate
          ? [this.issued_at.startDate, this.issued_at.endDate]
          : null;
        variables.slac = this.slac.length > 0 ? this.slac.join(",") : null;
        variables.locator = this.locator ? this.locator : null;
        variables.ticketno = this.ticketno ? this.ticketno : null;
        variables.isdifferent = this.differences;
      }
      variables.apply = false;

      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
            query tickets_routingfix(
              $dateformat: String
              $selected: [Ticket_input]
              $dateissued: [String]
              $locator: String
              $ticketno: String
              $slac: String
              $iszhold: Boolean
              $isdifferent: Boolean
              $apply: Boolean
            ) {
              tickets_routingfix(
                dateformat: $dateformat
                selected: $selected
                dateissued: $dateissued
                locator: $locator
                ticketno: $ticketno
                slac: $slac
                iszhold: $iszhold
                isdifferent: $isdifferent
                apply: $apply
              ) {
                id
                ticketno
                type
                locator
                dateissued
                passenger
                slac
                eventcode
                agent
                datetravel
                routing
                data
                status
              }
            }
          `,
          variables,
          fetchPolicy: 'no-cache'
        });

        if (response.data.tickets_routingfix.length > 0) {
          console.log(response.data.tickets_routingfix);
          this.tableItems(
            response.data.tickets_routingfix,
            this.options.bvtid,
            this.options.fields
          );
        }
      } catch (error) {
        console.log(error);
      }

      this.busy = false;
    },
    async _toolClick(a) {
      console.log("local toolClick: ", a);
      // this.cconfig.find((o) => o.key == "eventcode").value = this.eventcode;
      switch (a) {
        case "copy":
          this.copyit();
          break;
      }
      return;
    },
    _toolDisabled(a) {
      console.log("local toolDisabled: ", a);
      // switch (a) {
      //   case "lines":
      //     return this.btable_selected.length > 0 ? false : true;
      // }
    },

    async saveit() {
      console.log("saveit: ", this[this.options.bvtid + "_selected"][0]);
      let items = this[this.options.bvtid + "_selected"];
      this.busy = true;

      let variables = {
        selected: items,
        dateformat: "DD/MM/YY",
        apply: true,
      };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.query({
          query: gql`
            query tickets_routingfix(
              $selected: [Ticket_input]
              $dateformat: String
              $apply: Boolean
            ) {
              tickets_routingfix(
                selected: $selected
                dateformat: $dateformat
                apply: $apply
              ) {
                id
                ticketno
                type
                locator
                dateissued
                passenger
                slac
                eventcode
                agent
                datetravel
                routing
                data
                status
              }
            }
          `,
          variables,
        });

        if (response.data.tickets_routingfix.length > 0) {
          this.tableItems(
            response.data.tickets_routingfix,
            this.options.bvtid,
            this.options.fields
          );
        }
        this.message = "<span class='text-primary'>Saved it.</span>";
      } catch (error) {
        this.message = "<span class='text-danger'>" + error.message + "</span>";
      }
      // await this.load();
      this.busy = false;
    },
  },
};
</script>

<style>
</style>